/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_What_P3Inputs */

const en_home_what_p3 = /** @type {(inputs: Home_What_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What makes CADCraft different is who else can use it. Every menu item, tool and prompt is also a command that an AI agent can call. An agent can type into the command line like a person, send structured JSON, inspect the drawing to check its own work and render an image of the result. That makes CADCraft one of the first CAD programs designed from day one for automation and AI-assisted drafting.`)
};

/**
* | output |
* | --- |
* | "What makes CADCraft different is who else can use it. Every menu item, tool and prompt is also a command that an AI agent can call. An agent can type into th..." |
*
* @param {Home_What_P3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_what_p3 = /** @type {((inputs?: Home_What_P3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_What_P3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_what_p3(inputs)
});
export { home_what_p3 as "home.what.p3" }